const ACTIVE = 'ACTIVE'
const INACTIVE = 'INACTIVE'

const STATUS = {
  ACTIVE,
  INACTIVE,
}

const organizationUsers = {
  STATUS,
}

export default organizationUsers
